import { LitElement, html, svg } from 'lit';

export class IconShower32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Rennende dusjhode</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M28.5 31V9a8 8 0 0 0-15.998-.18"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6.5 15a6 6 0 1 1 12 0h-12ZM7.5 19l-1 3M4.5 28l-1 3M17.5 19l1 3M20.5 28l1 3M12.5 19v3M12.5 31v-3"></path></svg>`; }
}
if (!customElements.get('f-icon-shower32', IconShower32)) {
  customElements.define('f-icon-shower32', IconShower32);
}